import classNames from 'classnames';

import logo from '../../../images/darkLogo.svg';
import css from './Logo.css';

export interface LogoProps {
  size?: 'medium' | 'large';
  variant?: 'default' | 'light';
}

export default function Logo({ size = 'medium', variant = 'default' }: LogoProps) {
  return (
    <img
      className={classNames(css.root, { [css.large]: size === 'large', [css.light]: variant === 'light' })}
      alt="Flokk"
      src={logo}
    />
  );
}
